import { types } from './user-info.types';

export const getUserAgenciesRequest = () => ({
    type: types.GET_USER_AGENCIES_REQUEST,
});

export const getUserAgenciesSuccess = (data) => ({
    type: types.GET_USER_AGENCIES_SUCCESS,
    payload: data,
});

export const getUserAgenciesError = (error) => ({
    type: types.GET_USER_AGENCIES_ERROR,
    payload: error,
});

export const clearUserAgencies = () => ({
    type: types.CLEAR_USER_AGENCIES,
});

// All cities (lazy-loaded for admin Requests page)
export const getAllCitiesRequest = () => ({
    type: types.GET_ALL_CITIES_REQUEST,
});

export const getAllCitiesSuccess = (data) => ({
    type: types.GET_ALL_CITIES_SUCCESS,
    payload: data,
});

export const getAllCitiesError = (error) => ({
    type: types.GET_ALL_CITIES_ERROR,
    payload: error,
});

// Selected jurisdiction (traffic viewer)
export const setSelectedJurisdiction = (jurisdictionId) => ({
    type: types.SET_SELECTED_JURISDICTION,
    payload: jurisdictionId,
});
